const LimitTooltipHint = () => (
  <div>
    <p>
      <span className="font-semibold">Limit</span> hides posts from this domain
      unless followed
    </p>
    <p>
      <span className="font-semibold">Suspend</span> deletes all content from
      this domain
    </p>
    <p>
      <span className="font-semibold">Noop</span> only blocks media files
    </p>
  </div>
)

export default LimitTooltipHint
